import { postLogDetails } from "../Services/APIs/appDetails";

export const logEvent = ({ app, uid, event, error }) => {
    const payLoad = error ? `${event}: ${error.message || JSON.stringify(error)}` : event;
    postLogDetails({ app, uid, payLoad }).catch((e) => console.error("[logEvent] failed to log:", e));
};
